<template>
  <v-card class="mx-auto mb-2 card">
    <div
      class="card__inner"
      :style="{ backgroundImage: `url(${card.src})` }"
    ></div>
    <v-card-subtitle class="mb-2 pb-0"
      ><h3>{{ card.name }}</h3>
    </v-card-subtitle>
    <v-card-actions>
      <v-chip class="mr-2" :to="`${path}/show/${card.id}`">
        Show
      </v-chip>
      <v-chip class="mr-2" :to="`${path}/edit/${card.id}`">
        Edit
      </v-chip>
      <v-chip class="mr-2" @click="deleteItem(card.id)">
        Delete
      </v-chip>
    </v-card-actions>
  </v-card>
</template>

<script>
// @ is an alias to /src
import router from "@/router";
export default {
  name: "AdminCardTile",
  props: {
    card: Object,
    path: String,
  },
  methods: {
    deleteItem(id) {
      this.$parent.collection
        .doc(id)
        .delete()
        .then(() => {
          router.push({
            name: this.returnRoute,
          });
        })
        .catch((error) => {
          alert("Error removing document: ", error);
        });
    },
  },
};
</script>
